var map = {
	"./Beverage.png": 84,
	"./Breakfast.png": 85,
	"./Dinner.png": 86,
	"./Lunch.png": 39,
	"./Night.png": 87,
	"./Snacks.png": 88,
	"./fas-service-icon.png": 40,
	"./fresh-food-icon.png": 89,
	"./hero-banner-sm.png": 17,
	"./hero-banner1.png": 90,
	"./hero-banner2.png": 91,
	"./recipe.png": 30,
	"./star.png": 41,
	"./support-icon.png": 92
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83;